import {
  resolveProgressStatus,
  isError,
  isLoaded
} from '../../lib/progressStatus'

// Action Types
export const Types = {
  RESET: 'DADOS_BASICOS/RESET',
  SET_S3_PATH: 'DADOS_BASICOS/SET_S3_PATH',
  SET_ERROR: 'DADOS_BASICOS/SET_ERROR'
}

// Reducer
const initialState = {
  s3Path: undefined,
  error: false,
  loaded: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Types.SET_S3_PATH: {
      const status = resolveProgressStatus(action.payload)

      return {
        ...state,
        s3Path: action.payload,
        loaded: isLoaded(status),
        error: isError(status)
      }
    }
    case Types.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loaded: true
      }
    case Types.RESET:
      return initialState
    default:
      return state
  }
}

// Action Creators
export function setErrorDadosBasicos (data) {
  return {
    type: Types.SET_ERROR,
    payload: data
  }
}

export function setS3PathDadosBasicos (data) {
  return {
    type: Types.SET_S3_PATH,
    payload: data
  }
}

export function resetDadosBasicosTheme () {
  return {
    type: Types.RESET
  }
}
